import { SearchState, SearchActionTypes, searchActionNames } from './types';

const initialState: SearchState = {
  recent: [],
  result: [],
  selectedEntity: undefined,
  otaspStatus: undefined,
  hasError: false,
  updateRecent: false,
  deviceInfoError: false,
  deviceForbiddenError: false,
  internalServerError:false,
  gatewayTimeoutError:false,
  networkFailureError:false,
  deviceNotFoundError:false,
  telematicsIdError:false,
  selectedVIMSEntity: undefined,
  ecmData: [],
};

export const searchReducer = (
  state: SearchState = initialState,
  action: SearchActionTypes,
): SearchState => {
  switch (action.type) {
    case searchActionNames.SET_RECENT_SEARCHES: {
      return {
        ...state,
        recent: [...action.payload],
      };
    }
    case searchActionNames.ADD_RECENT_SEARCH_TEXT: {
      return {
        ...state,
        recent: [...state.recent, action.payload],
      };
    }
    case searchActionNames.ADD_RESULT: {
      return {
        ...state,
        result: [...state.result, action.payload],
      };
    }
    case searchActionNames.CLEAR_RESULT: {
      return {
        ...state,
        result: [],
      };
    }
    case searchActionNames.CLEAR_RECENT_SEARCH_TEXT: {
      return {
        ...state,
        recent: [],
      };
    }
    case searchActionNames.SET_SELECTED_ENTITY: {
      localStorage.removeItem('vimsSftpUserId')
      return {
        ...state,
        selectedEntity: action.payload,
      };
    }
    case searchActionNames.SET_HAS_ERROR_FLAG: {
      return {
        ...state,
        hasError: action.payload,
      };
    }
    case searchActionNames.SET_TELEMATICS_ID_ERROR: {
      return {
        ...state,
        telematicsIdError: action.payload,
      };
    }
    case searchActionNames.SET_UPDATE_RECENT_FLAG: {
      return {
        ...state,
        updateRecent: action.payload,
      };
    }
    case searchActionNames.SET_DEVICE_INFO_ERROR: {
      return {
        ...state,
        deviceInfoError: action.payload,
      };
    }
    case searchActionNames.SET_DEVICE_FORBIDDEN_ERROR: {
      return {
        ...state,
        deviceForbiddenError: action.payload,
      }
    }
    case searchActionNames.SET_DEVICE_NOT_FOUND_ERROR: {
      return {
        ...state,
        deviceNotFoundError: action.payload,
      };
    }
    case searchActionNames.SET_INTERNAL_SERVER_ERROR: {
      return {
        ...state,
        internalServerError: action.payload,
      };
    }
    case searchActionNames.SET_GATEWAY_TIMEOUT_ERROR: {
      return {
        ...state,
        gatewayTimeoutError: action.payload,
      };
    }
    case searchActionNames.SET_NETWORK_FAILURE_ERROR: {
      return {
        ...state,
        networkFailureError: action.payload,
      };
    }
    case searchActionNames.SET_OTASP_STATUS: {
      return {
        ...state,
        otaspStatus: action.payload,
      };
    }
    case searchActionNames.SET_SELECTED_VIMS_ENTITY: {
      return {
        ...state,
        selectedVIMSEntity: action.payload,
      };
    }
    case searchActionNames.SET_ECM_DATA: {
      return {
        ...state,
        ecmData: action.payload,
      };
    }
    default:
      return state;
  }
};
